import { FLYBITS } from '../../../constants';
import axios from '../../../utils/axios';
import { IDIConfig } from '../types/config';

export const updateConfig = async (accessToken: string, tenantId: string, partialConfig: any): Promise<IDIConfig> => {
    const response = await axios.put(FLYBITS.CONFIGS_HOST + `/tenants/${tenantId}/integrations`, {
        ...partialConfig,
        name: 'datafiniti',
    }, {
        headers: {
            Authorization: accessToken,
        },
        validateStatus: (status: number) => true,
    });
    return response.data
}

export const getConfig = async (accessToken: string, tenantId: string): Promise<IDIConfig> => {
    const response = await axios.get(FLYBITS.CONFIGS_HOST + `/tenants/${tenantId}/integrations/datafiniti?initialize=true`, {
        headers: {
            Authorization: accessToken,
        },
        validateStatus: (status: number) => true,
    });
    return response.data
}



// WEBPACK FOOTER //
// ./src/sub-projects/datafiniti/services/config.ts